import api from './api';

export async function getMainEvents({
  page = 1,
  limit = 50,
  search,
  year,
  month,
  category,
  city,
  status,
} = {}) {
  const params = { page, limit };
  if (search) params.search = search;
  if (year) params.year = year;
  if (month) params.month = month;
  if (category) params.category = category;
  if (city) params.city = city;
  if (status) params.status = status;
  const response = await api.get('/admin/main-events', { params });
  return response.data;
}

export async function importMainEvents({ file, mode, year, dryRun = false }) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('mode', mode);
  if (year) formData.append('year', String(year));
  if (dryRun) formData.append('dryRun', 'true');

  // The default JSON Content-Type would make axios serialise the FormData as JSON;
  // multipart/form-data lets the browser set the boundary.
  const response = await api.post('/admin/main-events/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000,
  });
  return response.data;
}
